export default class BikePriceInfoCreation {
  public price: number;
  constructor(price: number) {
    this.price = price;
  }
}
